"use strict";
// This code has been adapted from KatalMetricsSellerCentral
// https://code.amazon.com/packages/KatalMetricsSellerCentral/blobs/aa5508a70c21c1762d6840bd33cae457b2140014/--/src/detectDomainRealm.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectDomainRealm = void 0;
const SUBDOMAIN_REALM_MAP = {
    na: 'USAmazon',
    eu: 'EUAmazon',
    fe: 'FEAmazon',
    cn: 'CNAmazon',
};
/**
 * Determines the current domain and realm by reading the sushi URL placed on the window object.
 * If no URL is found, defaults to prod and USAmazon.
 *
 * @returns the detected domain and realm, or prod & USAmazon
 */
function detectDomainRealm() {
    const sushiUrl = window.ue_surl;
    const domain = detectDomain(sushiUrl) ?? 'prod';
    const realm = detectRealm(sushiUrl) ?? SUBDOMAIN_REALM_MAP.na;
    return { domain, realm };
}
exports.detectDomainRealm = detectDomainRealm;
function detectDomain(sushiUrl) {
    if (sushiUrl) {
        if (sushiUrl && sushiUrl.indexOf('nexusclient.prod') !== -1) {
            return 'prod';
        }
        else if (sushiUrl.indexOf('nexusclient.gamma') !== -1) {
            return 'test';
        }
    }
}
function detectRealm(sushiUrl) {
    const subdomain = sushiUrl?.match(/unagi[-]([a-z]{2})/);
    if (subdomain) {
        return SUBDOMAIN_REALM_MAP[subdomain[1]];
    }
}
